import NO_SITE_ACCESS_IMG from '@hotjar/shared-assets/images/error-403.png';
import { useCurrentSite } from '@hotjar/site';
import { useTranslation } from '@hotjar/translations';
import { BASE } from '@hotjar/webapp/constants/routes/overview';
import { getRoute } from '@hotjar/webapp/utils/routing';
import { Loader } from '@hotjar/hotsauce';
import { useNavigate } from 'react-router';
import { CentralMessage } from './CentralMessage';

export const NoSiteAccessRoute = (): JSX.Element | null => {
  const { t } = useTranslation('common', { keyPrefix: 'error-pages.no-site-access' });
  const { data, isLoading } = useCurrentSite();
  const navigate = useNavigate();

  if (!isLoading && data) {
    // If we have a current site we redirect to the overview page.
    navigate(
      getRoute(BASE.path, {
        siteId: data.id,
      }),
    );

    return null;
  }

  if (isLoading) {
    return <Loader />;
  }

  return (
    <CentralMessage
      pageImg={NO_SITE_ACCESS_IMG}
      pageTitle={t('title')}
      pageImgAlt={t('image-alt')}
      pageDescription={t('description')}
    />
  );
};
